<template>
  <dialog-base
    v-bind="$props"
    :key="renderKey"
    :external-activator="true"
    :header="$t('app.dialogs.connectionStatusDialog.headers.connectionStatus')"
    @close="close">
    <template #body>
      <strong>{{ $t('app.dialogs.connectionStatusDialog.headers.connectionStatus') }}:</strong>
      <span :class="`${connectionStatusColor}--text`">
        {{ ucWords($websocketConnectionStatus.state || '') }}
      </span>
      <br />
      <strong>{{ $t('app.dialogs.connectionStatusDialog.headers.lastConnectedAt') }}:</strong>
      <span :class="`${connectionStatusColor}--text`">
        {{ $websocketConnectionStatus.lastConnected }}
      </span>
      <br />
      <v-divider class="my-2"></v-divider>

      <h3>{{ $t('app.dialogs.connectionStatusDialog.headers.whatAreWebsockets') }}</h3>
      <div>
        {{ $t('app.dialogs.connectionStatusDialog.messages.whatAreWebsocketsParagraph') }}
      </div>

      <h3 class="pt-3">
        {{ $t('app.dialogs.connectionStatusDialog.headers.howDoesOpendockUseWebsockets') }}
      </h3>
      <div>
        {{
          $t('app.dialogs.connectionStatusDialog.messages.howDoesOpendockUseWebsocketsParagraph')
        }}
      </div>

      <h3 class="pb-1 pt-3">
        {{ $t('app.dialogs.connectionStatusDialog.headers.troubleshooting') }}
      </h3>
      <div>
        <strong>
          {{ $t('app.dialogs.connectionStatusDialog.headers.connectionFailsIntermittently') }}
        </strong>
        <br />
        <p>
          {{
            $t('app.dialogs.connectionStatusDialog.messages.connectionFailsIntermittentlyParagraph')
          }}
        </p>
        <strong>
          {{ $t('app.dialogs.connectionStatusDialog.headers.connectionAlwaysFails') }}
        </strong>
        <br />
        <p>
          {{
            $t('app.dialogs.connectionStatusDialog.messages.connectionAlwaysFailsParagraph', {
              subspaceUrl: config.subspace_url
            })
          }}
        </p>
      </div>
    </template>
  </dialog-base>
</template>

<script>
import { ucWords } from '@nova/core';
import dialogMixin from '@satellite/components/mixins/dialogMixin';
import connectionStatusMixin from '@/components/mixins/connectionStatusMixin';

export default {
  name: 'connection-status-dialog',
  mixins: [dialogMixin, connectionStatusMixin],
  data() {
    return { ucWords };
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>
